<template>
  <div>
    <v-flex xs12>
      梦加 spo
    </v-flex>

    <v-data-table
      :headers="headers"
      :items="data"
      hide-actions
      class="elevation-1"
    >

      <template slot="items" slot-scope="props">
        <td>{{ props.item.objectId }}</td>
        <!-- <td class="text-xs-right">{{ props.item.tempSleepId }}</td> -->
        <td class="text-xs-right">{{ props.item.ringDataVer }}</td>
        <td class="text-xs-right">{{ props.item.updatedAt | format }}</td>
        <td class="text-xs-right">{{ props.item.createdAt | format }}</td>
        <td class="justify-center px-0">
          <v-btn depressed icon small @click="navigateTo(props.item)">
            查看
          </v-btn>

          <v-btn depressed icon small @click="downloadBin(props.item)">
            下载
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <div class="text-xs-center">
      <v-pagination
        v-model="pagination.page"
        :length="pages"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { getSpoList, getSpoListCounts, getByObjectId } from '@/services/MjService'
import { dateFormat, base64ToArrayBuffer, saveByteArray, appendBuffer } from '@/utils/Util'

export default {
  data () {
    return {
      headers: [
        { align: 'center', text: 'objectId', sortable: false },
        // { align: 'center', text: 'tempSleepId', sortable: false },
        { align: 'center', text: 'ringDataVer', sortable: false },
        { align: 'center', text: 'updatedAt', sortable: false },
        { align: 'center', text: 'createdAt', sortable: false },
        { align: 'center', text: '', sortable: false }
      ],
      data: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  methods: {
    navigateTo (item) {
      this.$router.push({path: '/parsemj', query: {objId: item.objectId}})
    },
    async downloadBin (item) {
      const res = await getByObjectId(item.objectId)
      if (res.data.ringOriginalData) {
        let buffer = base64ToArrayBuffer(res.data.ringOriginalData)
        buffer = appendBuffer(new Uint8Array([5, 0, 0, 0]), buffer)
        saveByteArray(item.objectId + '.bin', buffer)
      }
    }
  },
  mounted: async function () {
    getSpoListCounts().then(res => {
      // console.log(res.data)
      this.pagination.totalItems = res.data.count
    }, err => console.error(err))
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null
      ) return 0
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  watch: {
    'pagination.page': {
      immediate: true,
      async handler (value) {
        const res = await getSpoList(10, 10 * (value - 1))
        this.data = res.data.results
      }
    }
  },
  filters: {
    format (value) {
      return dateFormat(new Date(value), 'yyyy-MM-dd hh:mm:ss')
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ListMjSpo.vue